import PropTypes from 'prop-types';
import React from 'react';
import {StyleSheet, View} from 'react-native';
import {getDataChart, getMaxChart} from './usage-chart-common';
import theme from '../../../theme-config';

const chartPadding = 20;

const Chart = () => null;

function getStyle() {
  return StyleSheet.create({
    chartContainer: {
      height: 150,
      backgroundColor: 'transparent',
      paddingRight: chartPadding,
    },
    chart: {
      height: 150,
      backgroundColor: 'transparent',
    },
  });
}

const UsageChart = props => {
  const styles = getStyle();
  const {data, max, onLayout, chartType = 'line'} = props;
  if (!data || data.points.length === 0 || data.labels.length === 0) {
    return <View />;
  }
  const {points, labels} = data;

  let maxChart;
  let dataCharts;
  let colorsChart;
  let fillsColor;
  const dataChart = getDataChart(points, labels, props.color);

  if (chartType === 'line') {
    maxChart = getMaxChart(labels, max, props.color);

    dataCharts = [maxChart.data, dataChart.data];
    colorsChart = [maxChart.color, dataChart.color];
    fillsColor = [maxChart.fillColor, dataChart.fillColor];
  } else {
    dataCharts = [dataChart.data];
    colorsChart = [dataChart.color];
  }

  return (
    <View style={styles.chartContainer}>
      <Chart
        type={chartType}
        data={dataCharts}
        showDataPoint
        hideVerticalGridLines
        hideHorizontalGridLines={chartType === 'line'}
        tightBounds
        dataPointRadius={0}
        color={colorsChart}
        lineWidth={2}
        onLayout={onLayout}
        showXAxisLabels={false}
        showYAxisLabels={chartType === 'bar'}
        verticalGridStep={2}
        fillColor={fillsColor}
        horizontalScale={3}
        style={styles.chart}
        axisColor={'#787878'}
        axisLabelColor={'#787878'}
        labelFontFamily={theme.fontFamily}
      />
    </View>
  );
};

UsageChart.propTypes = {
  data: PropTypes.shape({
    points: PropTypes.arrayOf(PropTypes.number),
    labels: PropTypes.arrayOf(PropTypes.string),
  }),
  color: PropTypes.string.isRequired,
  max: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  chartType: PropTypes.string,
  onLayout: PropTypes.func.isRequired,
};

export default UsageChart;
